import axios from 'axios';
import { API } from '../common/config-api';
import { getToken, removeToken, handleTokenRenewal } from '../auth/authService';

/**
 * Axios 인스턴스 생성
 * 모든 API 호출의 기본 설정을 담당합니다.
 */
const api = axios.create({
  baseURL: API.BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * 요청 인터셉터
 * JWT 토큰을 Authorization 헤더에 추가합니다.
 */
api.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * 응답 인터셉터
 * - 응답 후에 공통 처리를 수행합니다.
 * - Sliding Window 패턴: x-new-token 헤더 감지 시 토큰 갱신
 * - 401 에러 시 로그인 페이지로 리다이렉트
 */
let isRedirecting = false;

api.interceptors.response.use(
  (response) => {
    // Handle token renewal (Sliding Window)
    handleTokenRenewal(response);
    return response.data;
  },
  (error) => {
    // Handle 401 Unauthorized
    if (error.response && error.response.status === 401) {
      if (!isRedirecting) {
        isRedirecting = true;
        console.warn('Unauthorized: redirecting to login');
        removeToken();
        setTimeout(() => {
          window.location.href = '/login';
        }, 100);
      }
      return Promise.reject(error);
    }

    // 에러 처리
    if (error.response) {
      // 서버가 응답을 반환한 경우
      console.error('API Error:', error.response.status, error.response.data);
    } else if (error.request) {
      // 요청이 전송되었으나 응답이 없는 경우
      console.error('Network Error:', error.message);
    } else {
      // 요청 설정 중 에러 발생
      console.error('Request Error:', error.message);
    }
    return Promise.reject(error);
  }
);

export default api;
